export const environment = {
  apiBaseUri: 'https://convergent-prd-purview-api.azurewebsites.net/api',
  apimOverrideUri: 'https://api.getconvergent.io/carefindr',
  apiV2BaseUri: ''
};
